// @ts-nocheck
import { useGoogleLogin } from '@react-oauth/google'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { trackEvent } from '../../Analytics/GA'
import AxiosClass from '../../Api/Interceptor'
import UserApi from '../../Api/UserApi'
import { environment } from '../../AppConfig/environment'
import { loading, setAuthAlert } from '../../Redux/slices/userSlice'
import { loginThunk } from '../../Redux/thunks'
import { RouteConstants } from '../../Constants/routeConstants'
import googleIcon from '../../Assets/Images/google-icon.svg'

function GsignIn(props: any) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  
  const Glogin = useGoogleLogin({
    onSuccess: (tokenResponse: any) => {
      getProfileData(tokenResponse)
      trackEvent('Conversion Event', 'Google Sign In', 'Sign In/Sign Up')
    },
    onError: () => {
      console.log('Login Failed')
    },
  })

  const getProfileData = (tokenResponse: any) => {
    dispatch(loading(true))
    new UserApi(AxiosClass)
      .getUserInfoFromToken(tokenResponse.access_token)
      .then((data: any) => {
        dispatch(loading(false))
        const payload = {
          name: data.name,
          email: data.email,
          password: '',
          recaptcha_token: '',
          otp: '',
          access_token: tokenResponse.access_token,
          google_id: data.id,
          refresh_token: null,
          token_expiresIn: tokenResponse.expires_in,
          provider: 'google', // google or manual
        }
        dispatch(loginThunk(payload, navigate))
      })
      .catch(e => {
        console.error('Error getting user info from Google:', e)
        dispatch(loading(false))
        
        // If it's a user not found error, show appropriate message
        if (e.error?.name === 'generic/not-found') {
          dispatch(setAuthAlert({
            status: true,
            content: 'No account found with this Google account. Please sign up first.',
            name: 'generic/not-found'
          }))
        } else {
          dispatch(setAuthAlert({
            status: true,
            content: 'Google authentication failed. Please try again.',
            name: 'google-auth-error'
          }))
        }
      })
  }

  return (
    <button
      className="googleCta"
      onClick={() => {
        Glogin()
      }}
      type="button"
    >
      <span>
        <img src={googleIcon} alt="Google" />
      </span>
      {props.name} with Google
    </button>
  )
}

export default GsignIn
